<template>
  <div :class="`col-md-${width} form-group`">
    <label v-if="label" class="control-label">{{ `${label} ${required ? '*' : ''}` }}</label>
    <p v-if="help" class="help-block">{{ help }}</p>

    <div class="image-wrapper">
      <img v-if="typeData.url" :src="typeData.url" alt="" class="img-preview" />
      <img v-else-if="imagePreview" :src="imagePreview" alt="" class="img-preview" />

      <span class="image-delete" v-if="!disabled && (typeData.url || imagePreview)" @click="deleteSelectedImage">
        <i class="fa fa-close"></i>
      </span>

      <input type="file" class="form-control" :disabled="disabled" :required="isRequired" accept=".webp,.jpg,.jpeg,.png" ref="fileInput" v-on:change="handleImageChange" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    width: { type: String, default: '12' },
    name: { type: String, required: true },
    required: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
    url: {
      type: String | null,
      required: false,
    },
    label: String,
    help: String,
  },
  data() {
    return {
      typeData: {
        file: null,
        url: '',
        name: '',
      },
      imagePreview: null,
      maxFileSize: 1 * 1024 * 1024,
    };
  },
  watch: {
    url(newUrl) {
      if (typeof newUrl === 'string') {
        this.typeData.url = newUrl;
      }
    },
  },
  computed: {
    isRequired() {
      return this.required ? this.typeData.file === null && !this.typeData.url : false;
    },
  },
  methods: {
    generateImagePreview(imageToPreview) {
      if (imageToPreview) {
        const reader = new FileReader();

        reader.onload = (e) => {
          this.imagePreview = e.target.result;
        };

        reader.readAsDataURL(imageToPreview);
      }
    },
    handleImageChange(event) {
      const image = event.target.files[0];

      if (image.size > this.maxFileSize) {
        alert("L'immagine è troppo grande. La dimensione massima è 1MB.");
        this.$refs.fileInput.value = null;
        return;
      }

      // Trim spaces from the image name and remove the extension
      const trimmedName = image.name.replace(/\s+/g, '').split('.')[0];

      this.typeData.url = '';
      this.typeData.file = image;
      this.typeData.name = trimmedName;

      this.generateImagePreview(image);
      this.inputChange();
    },
    deleteSelectedImage() {
      this.typeData = {
        file: null,
        url: '',
        name: '',
      };

      this.imagePreview = null;
      this.$refs.fileInput.value = null;
      this.inputChange();
    },
    inputChange() {
      this.$emit('input', this.typeData);
    },
  },
  mounted() {
    if (this.url) {
      this.typeData.url = this.url;
    }
  },
};
</script>

<style scoped>
.image-wrapper {
  display: flex;
  align-items: center;
  position: relative;
}

.image-wrapper img {
  border: 1px solid #ccc;
}

.image-delete {
  position: absolute;
  top: -5px;
  font-size: 11px;
  border-radius: 50%;
  left: 22px;
  background-color: red;
  color: #fff;
  width: 15px;
  height: 15px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.img-preview {
  width: 34px;
  height: 34px;
  object-fit: cover;
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// resources/js/admin-panel/components/inputs/image.vue